import { Breadcrumb, Button, Col, Row, Typography } from "antd";
import React from "react";
import Spacer from "../../../../../../Components/Spacer";

const { Title } = Typography;

const QueueHeader = ({ shiftName = "-", onClickEndSession }) => {
  return (
    <Row justify="space-between" align="middle">
      <Col>
        <div>
          <Title level={3} style={{ margin: 0 }}>
            Manajemen Antrian ({shiftName})
          </Title>
          <Spacer height={8} />
          <Breadcrumb>
            <Breadcrumb.Item>
              <a href="/admin-dashboard">Manajemen Antrian</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Antrian Klinik</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </Col>
      <Col>
        <Button danger type="primary" size="large" onClick={onClickEndSession}>
          Akhiri Shift
        </Button>
      </Col>
    </Row>
  );
};

export default QueueHeader;
